import { Directive, ElementRef, HostListener, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ImpressionCounter } from '@composition_classes/impression-counter';
import { EntityTypeConfig } from '@model/entity-type-config';
import { EntityTypeConfigService } from '@service/entity-type-config.service';
import { ScrollService } from '@service/scroll.service';
import { EntityTypeIdentifier } from '@type/entity-type-identifier';
import { RestService } from '@service/rest/rest.service';
import { SentryService } from '@service/sentry.service';
import { StateService } from '@service/state.service';
import { ActivatedRoute, Router } from '@angular/router';

@Directive()
export abstract class EntityComponent implements OnInit {
  public abstract entityTypeIdentifier: EntityTypeIdentifier;

  public abstract getEntities(): Promise<void>;

  public entityTypeConfig: EntityTypeConfig = null;

  // IMPRESSIONCOUNTER
  // composition over inheritance
  public ImpressionCounter: ImpressionCounter = null;
  @HostListener('window:scroll', ['$event'])
  onScroll(event) {
    this.ImpressionCounter.onScroll(event);
  }
  @ViewChildren('impressionAnchor', { read: ElementRef })
  set anchors(anchors: QueryList<ElementRef>) {
    if (anchors && this.ImpressionCounter) this.ImpressionCounter.anchors = anchors;
  }

  constructor(
    protected EntityTypeConfigService: EntityTypeConfigService,
    protected ScrollService: ScrollService,
    protected RestService: RestService,
    protected SentryService: SentryService,
    public StateService: StateService,
    public Router: Router,
    public ActivatedRoute: ActivatedRoute,
  ) {
    this.ImpressionCounter = new ImpressionCounter({
      RestService,
      SentryService,
    });

    this.ActivatedRoute.queryParams.subscribe((queryParams) => {
      this.StateService.queryParams = queryParams;
    });
  }

  ngOnInit() {
    this.entityTypeConfig = this.EntityTypeConfigService.getConfigByName(this.entityTypeIdentifier);

    // get all entities
    this.getEntities().then(() => {
      // and if there is a scroll position remembered from list->detail->list - take it
      if (this.ScrollService.hookmatch(this.entityTypeConfig)) {
        // timeout for angular render cycle
        setTimeout(() => {
          this.ScrollService.restoreHookedScrollPosition();
        }, 150);
      }
    });
  }

  ngAfterViewInit() {
    this.ImpressionCounter.ngAfterViewInit();
  }

  changeFilter(
    filterAttributeNameOrObject: any,
    type: 'boolean' | 'string' | 'number',
    newValue = undefined,
  ): Promise<void> {
    return new Promise((resolve, reject) => {
      let newQueryParams = JSON.parse(JSON.stringify(this.StateService.queryParams));

      // reset filters on request
      if (filterAttributeNameOrObject.isFilterReset) {
        for (let key in newQueryParams) {
          if (newQueryParams.hasOwnProperty(key)) {
            newQueryParams[key] = null;
          }
        }
      } else {
        if (type == 'boolean') {
          if (typeof newValue != 'undefined') newQueryParams[filterAttributeNameOrObject] = newValue;
          else if (this.StateService.queryParams[filterAttributeNameOrObject] == 'true')
            delete newQueryParams[filterAttributeNameOrObject];
          else newQueryParams[filterAttributeNameOrObject] = 'true';
        } else if (type == 'string') {
          if (newValue == '' || newValue == null) delete newQueryParams[filterAttributeNameOrObject];
          else newQueryParams[filterAttributeNameOrObject] = newValue;
        } else if (type == 'number') {
          if (newValue == null) delete newQueryParams[filterAttributeNameOrObject];
          else newQueryParams[filterAttributeNameOrObject] = newValue;
        }
      }

      this.Router.navigate([], { queryParams: newQueryParams }).then(() => {
        this.applyFilters();
        resolve();
      });
    });
  }

  applyFilters() {
    this.getEntities();
  }
}
